import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/animations.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Intercepter et logger toutes les erreurs
window.addEventListener('error', (event) => {
  console.error('⚠️ Global error:', event.error);
  console.error('Stack:', event.error?.stack);
  return true;
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('⚠️ Unhandled Promise Rejection:', event.reason);
});

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Disabled in development to prevent errors when switching browser tabs
// Uncomment the line below to enable in production:
// reportWebVitals();
